<template lang="pug">
  #theawards.container.pb-1
    //- mobile
    #awards-carousel.d-none.d-lg-none.awards-carousel.carousel.slide(data-ride="false" data-touch="true" data-keyboard="true" data-pause="hover")
      .carousel-inner
        .carousel-item.active
          a(href="/winner-2018")
            .award-single-box
              .award-bg.first.text-center
                .h2.text-uppercase Testsieger
                  br
                  | seit 2018
                p Reisedealanbieter
                .award-img-wrapper
                  img(src="https://s3-cloud.td-cdn.de/Images/makaira/marketing/DtGV/2025/dtgv-siegel-25-testsieger-hoch.svg" alt="Testsieger seit 2018")
              .award-txt
                .award-shadow
                p touriDat ist offizieller Testsieger 2018, 2019, 2020, 2021, 2022 sowie 2025 und wurde durch die Deutsche Gesellschaft für Verbraucherstudien ausgezeichnet. Somit wurden die erheblichen Preisvorteile mit touriDat von unabhängiger Seite ebenso geprüft und bestätigt wie das einfache Handling und der 100%-Käuferschutz.

        .carousel-item
          a(href="/winner-2018")
            .award-single-box
              .award-bg.second.text-center
                .h2.text-uppercase Deutscher Kunden-Award
                  br
                  | seit 2019
                p 1. Platz Reisedeal-Anbieter
                .award-img-wrapper
                  img(src="https://td-cloud.s3.eu-central-1.amazonaws.com/Images/makaira/marketing/DtGV/2020-21/Awards-3column-grfx-2020-21-compressed.png" alt="Deutscher Kunden-Award 2020/21")
              .award-txt
                .award-shadow
                p In der branchenübergreifenden Kundenbefragung des unabhängigen Forschungsinstituts DtGV wurde touriDat von rund 330.000 Kunden unter 2.261 Unternehmen aus 233 Branchen mit dem „Deutschen Kunden-Award 2020/21“ für das hervorragende Preis-Leistungs-Verhältnis ausgezeichnet und zum besten Anbieter gewählt. Zusätzlich wurde touriDat in den Kategorien Top-Kundenzufriedenheit sowie Top-Kundenservice ausgezeichnet.

        .carousel-item
          a(href="/winner-2018")
            .award-single-box
              .award-bg.third.text-center
                .h2.text-uppercase trustami
                  br
                  | {{moment(new Date()).format("YYYY")}}
                p 5 von 5 Sternen – „Ausgezeichnet“
                .award-img-wrapper
                  img.lozad(data-src="https://cdn.trustami.com/userimages/55816/boxedMinicards/56bb3a3ccc96c5432a8b476a.png?widget=true" alt="trustami 2020")
              .award-txt
                .award-shadow
                p Seit über 25 Jahren bietet touriDat Kurzreisen und Hotelangebote zu besonders attraktiven Konditionen. Mit über {{trustamiVotes}} Bewertungen ist touriDat zudem erfolgreichster und beliebtester Anbieter von touriDays in Deutschland. Darüber hinaus bietet touriDat derzeit als einziger Anbieter einen 100%igen Käuferschutz gegen finanzielle Verluste wie z. B. Insolvenz des Gastgebers, Inhaberwechsel oder Betriebsschließung.


      a.carousel-control-prev(href="#awards-carousel" role="button" data-slide="prev" data-no-instant)
        span.carousel-control-prev-icon(aria-hidden="true")
        span.sr-only Previous
      a.carousel-control-next(href="#awards-carousel" role="button" data-slide="next" data-no-instant)
        span.carousel-control-next-icon(aria-hidden="true")
        span.sr-only Next


    //- desktop
    .row.d-flex(onclick="location.href='/winner-2018';")
      .col-md-4
        .award-single-box
          .award-bg.first.text-center
            .h2.text-uppercase Testsieger
              br
              | seit 2018
            p Reisedealanbieter
            .award-img-wrapper
              img(src="https://s3-cloud.td-cdn.de/Images/makaira/marketing/DtGV/2025/dtgv-siegel-25-testsieger-hoch.svg" alt="Deutscher Kunden-Award - Reisedealanbieter - Testsieger 2025 - Gesamt")
          .award-txt
            .award-shadow
            p touriDat ist offizieller Testsieger 2018, 2019, 2020, 2022 und 2025 und wurde durch die Deutsche Gesellschaft für Verbraucherstudien ausgezeichnet. Somit wurden die erheblichen Preisvorteile mit touriDat von unabhängiger Seite ebenso geprüft und bestätigt wie das einfache Handling und der 100%-Käuferschutz.
      .col-md-4.mt-lg-0.mt-sm-3.py-4.py-md-0
        .award-single-box
          .award-bg.second.text-center
            .h2.text-uppercase Deutscher Kunden-Award
              br
              | 2025
            p Note 1,4 (Sehr gut) im Preisvorteil
            .award-img-wrapper
              img(src="https://s3-cloud.td-cdn.de/Images/makaira/marketing/DtGV/2025/dtgv-siegel-25-preisvorteil-hoch.svg" alt="Deutscher Kunden-Award - Reisedealanbieter - Note 1,4 (Sehr gut) - Gesamtsieger")
          .award-txt
            .award-shadow
            p In der branchenübergreifenden Kundenbefragung des unabhängigen Forschungsinstituts DtGV wurde touriDat Gesamtsieger der Studie. touriDays erfüllte die gesetzten Kriterien insgesamt am besten und wurde Testsieger. Besonders in puncto Preisvorteil überzeugte das unser Portal mit vielen Schnäppchen.
      .col-md-4.mt-lg-0.mt-sm-3
        .award-single-box
          .award-bg.third.text-center
            .h2.text-uppercase Trustami
              br
              | {{moment(new Date()).format("YYYY")}}
            p 5 von 5 Sternen – „Ausgezeichnet“
            .award-img-wrapper
              img(src="https://cdn.trustami.com/userimages/55816/boxedMinicards/56bb3a3ccc96c5432a8b476a.png?widget=true" alt="trustami 2024")
          .award-txt
            .award-shadow
            p Seit über 25 Jahren bietet touriDat Kurzreisen und Hotelangebote zu besonders attraktiven Konditionen. Mit über {{trustamiVotes}} Bewertungen ist touriDat zudem erfolgreichster und beliebtester Anbieter von touriDays in Deutschland. Darüber hinaus bietet touriDat derzeit als einziger Anbieter einen 100%igen Käuferschutz gegen finanzielle Verluste wie z. B. Insolvenz des Gastgebers, Inhaberwechsel oder Betriebsschließung.

</template>

<script>
const moment = require("moment");
import mainData from "@/store/main.json";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Awards",
  props: {
    isMobileAppRunning: {
      type: Boolean,
      required: true
    }
  },
  setup() {
    return { trustamiVotes: mainData?.main?.trustamiVotes };
  },
  data() {
    return {
      moment: moment
    };
  }
};
</script>

<style scoped></style>
